@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply grid grid-cols-1 leading-4 relative text-2xs;

    span {
      @apply ease-in duration-150 transition-opacity;
      @apply col-span-full row-span-full self-start;
    }

    .default-text {
      @apply invisible opacity-0 text-neutral-dark;
    }

    .error-text {
      @apply invisible opacity-0 text-danger;
    }

    .active {
      /* z-10 makes the transition in safari less janky */
      @apply opacity-100 visible z-10;
    }
  }
}
